import React, { useEffect, useRef } from "react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

const UspSTEMPathwayMobile: React.FC = () => {
  const [emblaRef1, emblaApi1] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      containScroll: "trimSnaps",
      skipSnaps: false,
      align: "start",
    },
    [],
  );

  useEffect(() => {
    if (emblaApi1) {
      let interval: ReturnType<typeof setInterval>;

      const startReverseAutoplay = () => {
        interval = setInterval(() => {
          if (emblaApi1) {
            emblaApi1.scrollPrev();
          }
        }, 2000);
      };

      const stopReverseAutoplay = () => {
        if (interval) clearInterval(interval);
      };

      startReverseAutoplay();

      const emblaNode = emblaApi1.containerNode();
      if (emblaNode) {
        emblaNode.addEventListener("mouseenter", stopReverseAutoplay);
        emblaNode.addEventListener("mouseleave", startReverseAutoplay);
      }

      return () => {
        stopReverseAutoplay();
        if (emblaNode) {
          emblaNode.removeEventListener("mouseenter", stopReverseAutoplay);
          emblaNode.removeEventListener("mouseleave", startReverseAutoplay);
        }
      };
    }
  }, [emblaApi1]);

  const autoplayRef2 = useRef(
    Autoplay({
      delay: 2000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );

  const [emblaRef2, emblaApi2] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      containScroll: "trimSnaps",
    },
    [autoplayRef2.current],
  );

  useEffect(() => {
    if (emblaApi2 && autoplayRef2.current) {
      autoplayRef2.current.play();
    }
  }, [emblaApi2]);

  const universityLogos = [
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/michigan.webp",
      alt: "MBE",
      width: 70,
      height: 39,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/tulane.webp",
      alt: "MBE",
      width: 93,
      height: 30,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/new_york.webp",
      alt: "MBE",
      width: 44,
      height: 44,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/rochester_new.webp",
      alt: "MBE",
      width: 54,
      height: 44,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/seattle.webp",
      alt: "MBE",
      width: 42,
      height: 43,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/de_paul.webp",
      alt: "MBE",
      width: 67,
      height: 44,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/rit.webp",
      alt: "MBE",
      width: 34,
      height: 38,
    },
    {
      src: "https://ik.imagekit.io/mileseducation/miles_website/accounting/usp/rider_new.webp",
      alt: "MBE",
      width: 78,
      height: 20,
    },
  ];

  const companyLogos = [
    {
      src: "/images/accounting/usp/SDK.svg",
      alt: "MBE",
      width: 56,
      height: 24,
    },
    {
      src: "/images/accounting/usp/Williams.svg",
      alt: "MBE",
      width: 60,
      height: 14,
    },
    {
      src: "/images/accounting/usp/rsmMob.svg",
      alt: "MBE",
      width: 60,
      height: 20,
    },
    {
      src: "/images/accounting/usp/MBE_mob.svg",
      alt: "MBE",
      width: 58,
      height: 18,
    },
    {
      src: "/images/accounting/usp/hancock.svg",
      alt: "MBE",
      width: 106,
      height: 24,
    },
    { src: "/accounting/smitt.svg", alt: "MBE", width: 78, height: 24 },
    { src: "/accounting/smi.svg", alt: "MBE", width: 112, height: 24 },
    { src: "/accounting/caps.svg", alt: "MBE", width: 104, height: 24 },
    {
      src: "/images/accounting/usp/BDOmob.svg",
      alt: "MBE",
      width: 48,
      height: 18,
    },
  ];

  // Duplicate arrays for seamless infinite scroll
  const universityLogosDuplicated = [
    ...universityLogos,
    ...universityLogos,
    ...universityLogos,
  ];
  const companyLogosDuplicated = [
    ...companyLogos,
    ...companyLogos,
    ...companyLogos,
  ];

  return (
    <>
      <div className="w-full md:pt-[60px] pt-[30px] md:pb-[80px] pb-[30px] bg-[#0C1F33] relative z-[9]">
        <Image
          src="/images/accounting/usp/Payment-mount.png"
          alt="Special Offer"
          className="mx-auto absolute md:bottom-0 bottom-0 left-0 w-full z-[-1]"
          width={360}
          height={327}
          priority
        />
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0">
          <div className="text-center">
            <h2 className="font-semibold md:text-[36px] text-[20px]  text-[#fff] text-center mb-6 leading-6">
              What is the US Pathway
              <br />
              <span className="border-[#ca7216] border-b-2 inline-block ml-[5px]">
                for Global Accountants?
              </span>
            </h2>
          </div>

          <div className="w-[340px] mx-auto">
            <div className="relative">
              <Image
                src="/images/accounting/usp/yellow.svg"
                alt="universities"
                className="w-[340px] mx-auto"
                width={328}
                height={170}
                priority
              />
              <div className="flex items-center justify-start absolute top-0 left-0 w-full h-full">
                <div className="w-[50%] text-center">
                  <p className=" text-center text-[#3B3B3B] text-[22px] font-bold tracking-[0.66px] leading-6">
                    1 year of <br /> Study
                  </p>
                  <p className="bg-[#FFBA08] text-black font-semibold text-[10px] inline-block px-1">
                    STEM-designated
                  </p>
                </div>
                <div className="w-[28%] text-center overflow-hidden">
                  <p className="text-center text-[10px] text-[#A05200] font-medium pb-6 tracking-[-0.3px] leading-normal">
                    Master's from top University in the US
                  </p>
                  <div className="">
                    <div
                      className="embla overflow-hidden w-full"
                      ref={emblaRef1}
                    >
                      <div
                        className="embla__container flex"
                        style={{
                          backfaceVisibility: "hidden",
                          transform: "translate3d(0, 0, 0)",
                        }}
                      >
                        {universityLogosDuplicated.map((logo, index) => (
                          <div
                            key={`university-${index}`}
                            className="embla__slide flex-[0_0_auto] flex-shrink-0 flex items-center justify-center"
                            style={{
                              minWidth: "60px",
                              marginRight: "10px",
                            }}
                          >
                            <Image
                              src={logo.src}
                              alt={logo.alt}
                              className="mx-auto"
                              width={logo.width}
                              height={logo.height}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <Image
                src="/images/accounting/usp/blue.svg"
                alt="companies"
                className="w-[340px] mx-auto"
                width={328}
                height={170}
                priority
              />
              <div className="flex items-center justify-end absolute top-0 left-0 h-full w-full">
                <div className="w-[28%] text-center">
                  <p className="text-center text-[10px] text-[#00478E] font-medium pb-5 tracking-[-0.3px] leading-normal">
                    Jobs at CPA firms <br /> in the US
                  </p>
                  <div className="">
                    <div
                      className="embla overflow-hidden w-full"
                      ref={emblaRef2}
                    >
                      <div
                        className="embla__container flex"
                        style={{
                          backfaceVisibility: "hidden",
                          transform: "translate3d(0, 0, 0)",
                        }}
                      >
                        {companyLogosDuplicated.map((logo, index) => (
                          <div
                            key={`company-${index}`}
                            className="embla__slide flex-[0_0_auto] flex-shrink-0 flex items-center justify-center"
                            style={{
                              minWidth: "60px",
                              marginRight: "10px",
                            }}
                          >
                            <Image
                              src={logo.src}
                              alt={logo.alt}
                              className="mx-auto"
                              width={logo.width}
                              height={logo.height}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[50%] text-center overflow-hidden">
                  <p className="text-center text-[#3B3B3B] text-[22px] font-bold tracking-[0.66px] leading-6">
                    3 years of <br /> Work
                  </p>
                  <p className="text-[#555] font-medium text-[9px]">
                    Starting Salary
                  </p>
                  <p className="bg-[#FFBA08] text-black font-semibold text-[10px] inline-block px-1">
                    $60K+
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center relative mt-6">
            <h2 className="text-[20px] lg:text-[40px] md:text-[38px] lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-white font-semibold text-center inline-block mx-auto px-[4px]">
              <span className="border-[#ca7216] border-b-2 inline-block">
                Let’s talk ROI
              </span>
            </h2>
          </div>

          <div className="relative z-10 w-[340px] mx-auto">
            <div className="bg-[#fff] border-[#F0F0F2] border-[6px] rounded-[10px] mt-4 px-4 z-10 relative">
              <div className="flex justify-center items-center gap-2 ">
                <Image
                  src="/cpa/generic/inves.png"
                  alt="Special Offer"
                  className=""
                  width={36}
                  height={39}
                  priority
                />
                <span className="text-[20px] font-semibold ">Investment</span>
              </div>

              <div className="rounded-[8px] text-center py-2 border-[#EDEDF0] border-[1px] bg-[#F8F8F8] font-semibold text-[14px] text-[#000F34B2] mt-2">
                Out of Pocket $2K<sup className="text-[8px]">^</sup>
                <br /> + 
                <br /> Student Loan
              </div>
              <p className="font-medium text-[8px] text-[#000f3480] mt-[5px]">
                ^Estimated
              </p>
            </div>

            <div className="bg-[#fff] border-[#F0F0F2] border-[6px] rounded-[10px] mt-4 px-4 py-3 z-10 relative">
              <div className="flex justify-center items-center gap-2 ">
                <Image
                  src="/cpa/generic/return.png"
                  alt="Special Offer"
                  className=""
                  width={36}
                  height={39}
                  priority
                />
                <span className="text-[20px] font-semibold ">Returns</span>
              </div>

              <div className="rounded-[8px] text-center py-2 border-[#EDEDF0] border-[1px] bg-[#F8F8F8] font-semibold text-[14px] text-[#000F34B2] mt-2">
                Salary: <br /> $60K+
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UspSTEMPathwayMobile;
